export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6891.9215bef4.jpg";